<template>
    <div>
        <v-chart-stock-trend :style="chart_style()" :options="line" :autoresize="true" />
    </div>
</template>

<script>
	import ECharts from 'vue-echarts'
	import axios from 'axios'
	import {
		request_zzquant
	} from "network/request.js"

	const upColor = '#ec0000';
	const upColor2 = '#4e0809';
	const upBorderColor = '#8A0000';
	const downColor = '#00da3c';
	const downColor2 = '#0c571c';
	const downBorderColor = '#008F28';

	export default {
		props: {
			title: String,
			subText: String,
			symbol_code: String,
			chart_heigh:{type:String,default:'600px'},
			chart_width:{type:String,default:'100%'},
			selected_date: String, // 新增prop接收选中的日期
		},
		watch: {
			symbol_code: 'refresh',
			selected_date: 'refresh' // 监听日期变化，重新加载数据
		},
		computed: {

		},
		components: {
			'v-chart-stock-trend': ECharts
		},
		data() {
			return {
				line: {
					title: {
						text: this.title,
						subtext: this.subText,
						left: '1%',
						// textAlign:'right',
						textStyle: {
							color: '#999999'
						},
						subtextStyle: {
							color: '#666666'
						}
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						}
					},
					axisPointer: {
						link: {xAxisIndex: 'all'},
						// label: {
						// 	backgroundColor: '#777'
						// }
					},
					legend: {
						top: 10,
						show: false,
						left: 'center',
						data: ['K', 'AVG', 'V']
					},
					visualMap: [{
						show: false,
						seriesIndex: 2,
						dimension: 2,
						pieces: [{
							value: 0,
							color: downColor
						}, {
							value: 1,
							color: upColor
						}, {
							value: 2,
							color: 'gray'
						}]
					}, {
						// top: 10,
						// right: 10,
						type: 'piecewise',
						show: false,
						seriesIndex: [0],
						dimension: 1,
						pieces: [{
								min: parseFloat(10),
								max: parseFloat(21),
								color: upColor2
							},
							{
								min: parseFloat(5),
								max: parseFloat(10),
								color: upBorderColor
							},
							{
								min: parseFloat(0),
								max: parseFloat(5),
								color: upColor
							},
							{
								min: parseFloat(-5),
								max: parseFloat(0),
								color: downColor
							},
							{
								min: parseFloat(-10),
								max: parseFloat(-5),
								color: downBorderColor
							},
							{
								min: parseFloat(-21),
								max: parseFloat(-10),
								color: downColor2
							}
						],
						outOfRange:{
							color:"#000"
						}
					}],
					grid: [{
							left: '10%',
							right: '8%',
							height: '50%'
						},
						{
							left: '10%',
							right: '8%',
							top: '63%',
							height: '25%'
						}
					],
					xAxis: [{
							type: 'category',
							scale: true,
							boundaryGap: false,
							splitLine: {
								show: false
							},
							splitNumber: 20,
							min: 'dataMin',
							max: '15:00',
							axisPointer: {
								z: 100
							},
							axisLabel: {
								interval: 29,
								formatter: function(value) {
									return value === '09:30' ? '    9:30' : (value === '15:00' ? '15:00    ' : value)
								},
								fontSize: 10,
								color: '#999999'
							},
							axisLine: {
								onZero: false,
								lineStyle: {
									color: '#666666'
								}
							},
						}, {
							gridIndex: 1,
							type: 'category',
							scale: true,
							boundaryGap: false,
							axisLine: {
								onZero: false,
								lineStyle: {
									color: '#666666'
								}
							},
							axisTick: {
								show: false
							},
							splitLine: {
								show: false
							},
							axisLabel: {
								show: false
							},
							splitNumber: 20,
							min: 'dataMin',
							max: 'dataMax'
						}
					],
					yAxis: [{
							scale: true,
							offset: 1,
							splitLine: {
								show: false
							},
							splitArea: {
								show: true
							},
							axisLine: {
								lineStyle: {
									color: '#666666',
									width: 1
								}
							},
							position: 'left',
							// min: -10,
							min: function(value) {
								return value.min > -10 ? -10 : value.min
							},
							// max: 10,
							max: function(value) {
								return value.max < 10 ? 10 : value.max
							},
							axisLabel: {
								formatter: '{value}%',
								fontSize: 10,
								color: '#999999'
							}
						},
						{
							scale: true,
							position: 'right',
							gridIndex: 1,
							splitNumber: 2,
							axisLabel: {
								show: false
							},
							axisLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							splitLine: {
								show: false
							},
						}, {
							//name:'price',
							scale: true,
							splitArea: {
								show: false
							},
							splitLine: false,
							position: 'right',
							axisLabel: {
								show: true,
								fontSize: 10,
								color: '#999999'
							},
							axisLine: {
								lineStyle: {
									color: '#666666',
									width: 1
								}
							},
						},
					],
					series: [{
							name: '涨幅',
							type: 'line',
							showSymbol: false,
							symbol: 'circle',
							lineStyle: {
								normal: {
									width: 1,
									// color: '#92BFD0'
								}
							},
							markPoint: {
								symbol: 'circle', //标记类型
								symbolSize: 3,
								itemStyle: {
									normal: {
										label: {
											show: true,
											fontSize: 10,
											color: 'rgba(235,50,60,0.7)',
											position: 'right',
											fontWeight: '',
										}
									}
								},
							}
						},
						{
							name: '均涨幅',
							type: 'line',
							showSymbol: false,
							symbol: 'circle',
							smooth: true,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 1,
									color: '#FFC04C'
								}
							}
						},
						{
							name: '量能',
							type: 'bar',
							xAxisIndex: 1,
							yAxisIndex: 1,
							markPoint: {
								symbol: 'circle', //标记类型
								symbolSize: 3,
								itemStyle: {
									normal: {
										label: {
											show: true,
											fontSize: 10,
											color: 'rgba(235,50,60,0.7)',
											position: 'right',
											fontWeight: '',
										}
									}
								}
							},
						},
					],
				}
			}
		},
		mounted() {
			// console.log("mounted");
			this.refresh();
		},
		methods: {
			chart_style() {
				return {
					width: this.chart_width,
					height: this.chart_heigh,
				}
			},
			calculateMA(dayCount, data) {
				var result = [];
				for (var i = 0, len = data.values.length; i < len; i++) {
					if (i < dayCount) {
						result.push('-');
						continue;
					}
					var sum = 0;
					for (var j = 0; j < dayCount; j++) {
						sum += data.values[i - j][1];
					}
					result.push(+(sum / dayCount).toFixed(2));
				}
				return result;
			},
			refresh() {
				// 根据symbol_code和selected_date加载分时图数据
				if (!this.symbol_code) return;
				
				// 发送请求获取数据
				this.line['title'] = {
					text: this.title,
					subtext: this.subText,
					// left: 0
				};
				if (this.symbol_code.length != 6) {
					return
				}
				let url1 = '/v3/market/trend/' + this.symbol_code;
				if (this.selected_date) {
					url1 = url1 + '/date/' + this.selected_date;
				}

				axios.all([
						request_zzquant({
							'url': url1
						}),

					])
					.then(axios.spread((resp1) => {
						// console.log(date,resp1);
						let splitDataItem = this.splitData(resp1['data']['data']);
						// if(date){
						// 	var key = 'strend';
						// 	if (this.symbol_code.substring(0, 1) == '8') key = 'ptrend';
						// 	splitDataItem = this.splitData(resp1['data']['data'][key]);
						// }

						// 更新title
						this.line['title'] = {
							text: this.title,
							subtext: resp1['data']['data']['day'],
							textStyle: {
								color: '#999999'
							},
							subtextStyle: {
								color: '#666666'
							}
						};
						this.line['xAxis'] = [{
							data: splitDataItem.categoryData,
						},{
							data: splitDataItem.categoryData,
						}]
                        let series_data = []
                        series_data.push({
                            name: 'K',
                            type: 'line',
                            showSymbol: false,
                            symbol: 'circle',
                            data: splitDataItem.values_price_pct,
                            markPoint: {
                                data: [{
                                    value: splitDataItem.values_price_pct[0],
                                    yAxis: splitDataItem.values_price_pct[0],
                                    xAxis: '9:30'
                                }],
                            },
                        });
                        series_data.push({
                            name: 'AVG',
                            type: 'line',
                            showSymbol: false,
                            symbol: 'circle',
                            smooth: true,
                            data: splitDataItem.values_price_avg_pct
                        });
                        series_data.push({
                            name: 'V',
                            type: 'bar',
                            xAxisIndex: 1,
                            yAxisIndex: 1,
                            data: splitDataItem.values_volume,
                            markPoint: {
                                data: [{
                                    type: 'max',
                                    name: '最大值',
                                    label: {
                                        position: 'top',
                                        color: 'rgba(200,0,0,0.8)'
                                    }
                                }]
                            }
                        });


						this.line['series'] = series_data
					}))
					.catch(err => {
						console.log(err);
					})
			},
			pct_pcire(pre_close, price) {
				if (price == 0) {
					return 0;
				}
				return ((price - pre_close) / pre_close * 100).toFixed(2);
			},
			splitData(rawData) {
				// console.log(rawData)
				let [categoryData, values_price_pct, values_price, values_price_avg_pct, values_volume, values_up] = [
					[],
					[],
					[],
					[],
					[],
					[]
				]
				var pre_close = rawData['preclose_px'];
				// var trend = rawData['trend'];
				// for (var i = 0; i < trend.length; i++) {
				// 	categoryData.push(trend[i][0]);
				// 	values_price_pct.push(this.pct_pcire(pre_close, trend[i][1]));
				// 	values_price.push(trend[i][1]);
				// 	values_price_avg_pct.push(this.pct_pcire(pre_close, trend[i][2]));
				// 	values_volume.push([i, trend[i][3], trend[i][4]]);
				// 	values_up.push(trend[i][4]);
				// }
				let trend_idx = 0
				if (rawData['trend']) {
					rawData['trend'].forEach(trend => {
						categoryData.push(trend[0]);
						values_price_pct.push(this.pct_pcire(pre_close, trend[1]));
						values_price.push(trend[1]);
						values_price_avg_pct.push(this.pct_pcire(pre_close, trend[2]));
						values_volume.push([trend_idx, trend[3], trend[4]]);
						values_up.push(trend[4]);
						trend_idx += 1;
					})
				}

				return {
					categoryData: categoryData,
					values_price_pct: values_price_pct,
					values_price: values_price,
					values_price_avg_pct: values_price_avg_pct,
					values_volume: values_volume,
					values_up: values_up,
				};
			}
		}
	}
</script>

<style>
	.chart_stock_kline_popular {
		width: 100%;
		height: 600px;
	}
</style>
